export default "__VITE_ASSET__eb7eMLq8__"